<template>
  <div class="controles">
    <div class="boton">
      <input
        type="radio"
        id="elementos"
        name="elementos"
        value="elementos"
        v-model="seleccion"
        checked
      />
      <label for="elementos">Elementos desplegados</label>
    </div>
    <div class="boton">
      <input
        type="radio"
        id="puestos"
        name="puestos"
        value="puestos"
        v-model="seleccion"
      />
      <label for="puestos">Puestos de rescate humanitario</label>
    </div>
  </div>

  <div class="tooltip-militarizacion" id="tooltip-militarizacion">
    <span class="highlight">{{ valor_tooltip }}</span>
  </div>

  <div class="contenedor-lineas-militares" id="contenedor-lineas-militares">
    <svg
      id="svg_lineas"
      class="svg-lineas"
      :width="ancho + margenes.derecha + margenes.izquierda"
      :height="alto_svg"
    >
      <g
        class="eje-x"
        :transform="`translate(${margenes.izquierda},${
          margenes.arriba + alto
        })`"
      ></g>
      <g
        class="eje-y"
        :transform="`translate(${margenes.izquierda},${margenes.arriba})`"
      ></g>
      <g
        class="grupo-lineas"
        :transform="`translate(${margenes.izquierda},${margenes.arriba})`"
      ></g>
      <g
        class="grupo-circulos"
        :transform="`translate(${margenes.izquierda},${margenes.arriba})`"
      ></g>
    </svg>
  </div>
</template>

<script setup>
import * as d3 from "d3";
import { onMounted, onUnmounted, ref, watch } from "vue";

const seleccion = ref("elementos");
const color_dict = ref({
  "Guardia Nacional": "#3A5CA6",
  "Secretaría de Defensa Nacional": "#796952",
});
const datos = ref({
  elementos: [
    {
      key: "Guardia Nacional",
      values: [
        { anio: 2019, numero: 2980 },
        { anio: 2020, numero: 0 },
        { anio: 2021, numero: 913 },
        { anio: 2022, numero: 4152 },
        { anio: 2023, numero: 525 },
        { anio: 2024, numero: 1115 },
      ],
    },
    {
      key: "Secretaría de Defensa Nacional",
      values: [
        { anio: 2019, numero: 3330 },
        { anio: 2020, numero: 2982 },
        { anio: 2021, numero: 7419 },
        { anio: 2022, numero: 7419 },
        { anio: 2023, numero: 7419 },
        { anio: 2024, numero: 7959 },
      ],
    },
  ],
  puestos: [
    {
      key: "Guardia Nacional",
      values: [
        { anio: 2019, numero: 13 },
        { anio: 2020, numero: 13 },
        { anio: 2021, numero: 13 },
        { anio: 2022, numero: 22 },
        { anio: 2023, numero: 22 },
        { anio: 2024, numero: 41 },
      ],
    },
  ],
});
const data = ref();
const data_circulos = ref([]);
const max_value = ref();
const radio = ref(3);

const contenedor_svg = ref();
const svg = ref();
const ancho = ref(0);
const alto_svg = ref(550);
const alto = ref(0);
const margenes = ref({
  derecha: 20,
  izquierda: 65,
  abajo: 35,
  arriba: 20,
});

const grupo_lineas = ref();
const grupo_circulos = ref();
const escalaX = ref();
const escalaY = ref();
const eje_X = ref();
const eje_Y = ref();
const texto_x = ref();
const texto_y = ref();
const nombre_y = ref();
const formatoTemporal = ref(d3.timeParse("%Y"));

const tooltip_militarizacion = ref();
const format = ref(d3.format(",.0f"));
const valor_tooltip = ref(null);

onMounted(() => {
  contenedor_svg.value = document.getElementById(`contenedor-lineas-militares`);
  svg.value = d3.select(`svg#svg_lineas`);
  eje_X.value = svg.value.select("g.eje-x");
  eje_Y.value = svg.value.select("g.eje-y");
  grupo_lineas.value = svg.value.select("g.grupo-lineas");
  grupo_circulos.value = svg.value.select("g.grupo-circulos");
  texto_x.value = svg.value.append("text").attr("text-anchor", "middle");
  texto_y.value = svg.value.append("text").attr("text-anchor", "middle");
  tooltip_militarizacion.value = d3.select("div#tooltip-militarizacion");
  tooltip_militarizacion.value.style("visibility", "hidden");

  //console.log(data_circulos.value);
  setData();
  dimensionandingLineas();
  graficaLineas();
  window.addEventListener("resize", reescalanding);
});
onUnmounted(() => {
  window.removeEventListener("resize", reescalanding);
});
watch(seleccion, () => {
  setData();
  dimensionandingLineas();
  graficaLineas();
});

function setData() {
  data.value = datos.value[seleccion.value];
  if (seleccion.value == "elementos") {
    max_value.value = 8000;
    nombre_y.value = "Elementos desplegados";
  } else if (seleccion.value == "puestos") {
    max_value.value = 45;
    nombre_y.value = "Puestos de rescate humanitario";
  }

  data_circulos.value = [];
  data.value.map((d) => {
    let fuente = d.key;
    for (let i = 0; i < d.values.length; i++) {
      data_circulos.value.push({
        fuente: fuente,
        anio: d.values[i]["anio"],
        numero: d.values[i]["numero"],
      });
    }
  });
  //console.log(data_circulos.value);
}

function reescalanding() {
  dimensionandingLineas();
  graficaLineas();
}
function dimensionandingLineas() {
  ancho.value =
    contenedor_svg.value.clientWidth -
    margenes.value.derecha -
    margenes.value.izquierda;
  alto.value = alto_svg.value - margenes.value.arriba - margenes.value.abajo;

  escalaX.value = d3
    .scaleTime()
    .domain([formatoTemporal.value(2019), formatoTemporal.value(2024)])
    .range([0, ancho.value]);

  escalaY.value = d3
    .scaleLinear()
    .domain([0, max_value.value])
    .range([alto.value, 0]);

  eje_X.value.call(d3.axisBottom(escalaX.value));
  eje_Y.value.call(d3.axisLeft(escalaY.value));

  texto_x.value
    .attr(
      "x",
      (ancho.value + margenes.value.izquierda + margenes.value.derecha) / 2
    )
    .attr("y", alto.value + margenes.value.arriba + margenes.value.abajo - 2)
    .attr("font-size", "14")
    .attr("font-family", "Avenir, Helvetica, Arial, sans-serif")
    .attr("font-weight", "bold")
    .text("Año");

  texto_y.value
    .attr("transform", "rotate(-90)")
    .attr("y", 15)
    .attr("x", -(alto.value + margenes.value.arriba + margenes.value.abajo) / 2)
    .attr("font-size", "14")
    .attr("font-weight", "bold")
    .attr("font-family", "Avenir, Helvetica, Arial, sans-serif")
    .text(nombre_y.value);
}

function graficaLineas() {
  // Primero agregamos las líneas
  grupo_lineas.value
    .selectAll("path")
    .data(data.value)
    .join(
      (enter) => {
        enter
          .append("path")
          .attr("stroke", (d) => color_dict.value[d.key])
          .attr("stroke-width", 2.5)
          .attr("fill", "none")
          .attr("d", (d) => {
            return d3
              .line()
              .x((d) => escalaX.value(formatoTemporal.value(d.anio)))
              .y((d) => escalaY.value(d.numero))(d.values);
          });
      },
      (update) => {
        update
          .transition()
          .attr("stroke", (d) => color_dict.value[d.key])
          .attr("stroke-width", 2.5)
          .attr("fill", "none")
          .attr("d", (d) => {
            return d3
              .line()
              .x((d) => escalaX.value(formatoTemporal.value(d.anio)))
              .y((d) => escalaY.value(d.numero))(d.values);
          });
      },
      (exit) => {
        exit.remove();
      }
    );

  // Ahora agregamos los círculos
  grupo_circulos.value
    .selectAll("circle")
    .data(data_circulos.value)
    .join(
      (enter) => {
        enter
          .append("circle")
          .attr("cx", (d) => escalaX.value(formatoTemporal.value(d.anio)))
          .attr("cy", (d) => escalaY.value(d.numero))
          .attr("r", radio.value)
          .attr("fill", (d) => color_dict.value[d.fuente])
          .on("mouseover", abrirTooltip)
          .on("mousemove", ajustarPosicionTooltip)
          .on("mouseleave", cerrarTooltip);
      },
      (update) => {
        update
          .transition()
          .attr("cx", (d) => escalaX.value(formatoTemporal.value(d.anio)))
          .attr("cy", (d) => escalaY.value(d.numero))
          .attr("r", radio.value)
          .attr("fill", (d) => color_dict.value[d.fuente]);
      },
      (exit) => {
        exit.remove();
      }
    );
}

function abrirTooltip() {
  let seleccion = d3.select(this).datum();
  valor_tooltip.value = format.value(seleccion.numero);

  tooltip_militarizacion.value.style("visibility", "visible");
}

const ajustarPosicionTooltip = function () {
  //console.log(d3.pointer(event, document.body));
  let position = d3.pointer(event, document.body);
  let x_cor = position[0];
  let w = window.innerWidth;

  //console.log(w, x_cor);
  if (w < 769) {
    // Si es la versión móvil
    if (x_cor + 100 > ancho.value) {
      // Y está muy a la derecha
      x_cor -= 70;
    } else {
      x_cor += 20;
    }
  } else {
    // Si es la versión de escritorio
    if (x_cor + 200 > w) {
      // Y está muy a la derecha
      x_cor -= 70;
    } else {
      x_cor += 20;
    }
  }

  tooltip_militarizacion.value
    .style("left", x_cor + "px")
    .style("top", position[1] + "px");
};
const cerrarTooltip = function () {
  tooltip_militarizacion.value.style("visibility", "hidden");
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.controles {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding-left: 10px;
}

.boton {
  width: 45%;
  text-align: left;
  display: inline;
  font-weight: bold;
}
.tooltip-militarizacion {
  position: absolute;
  z-index: 2;
  background-color: #252323;
  color: white;
  opacity: 0.93;
  height: auto;
  width: 60px;
  font-size: 14px;
  padding: 4px;
}

@media (max-width: 850px) {
  .boton {
    width: 100%;
  }
}
</style>
